import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CurrencyPipe, NgClass } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { CheckboxComponent, DropdownComponent, TooltipModule } from '@libs/ui-lib';
import { TypedChanges } from '@libs/utils';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { TreatmentCardProviderVM, TreatmentCardVM } from './treatment-card.vm';

@Component({
  selector: 'lib-treatment-card',
  imports: [
    SvgIconComponent,
    CurrencyPipe,
    CheckboxComponent,
    NgClass,
    ReactiveFormsModule,
    DropdownComponent,
    TranslateModule,
    TooltipModule,
  ],
  templateUrl: './treatment-card.component.html',
  styleUrl: './treatment-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreatmentCardComponent implements OnChanges {
  @Input({ required: true }) public treatment!: TreatmentCardVM;
  @Input() public providers: TreatmentCardProviderVM[] = [];

  // TODO: rename this to avoid using native DOM names
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public toggle = new EventEmitter<void>();
  @Output() public providerChange = new EventEmitter<string>();

  protected opened = false;
  protected overlayPositionStrategy: ConnectedPosition[] = [
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top',
      offsetY: 10,
    },
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom',
      offsetY: -10,
    },
  ];

  protected onToggleClick(): void {
    this.opened = !this.opened;
  }

  protected readonly isSelectedControl = new FormControl(true);

  constructor() {
    this.isSelectedControl.valueChanges.subscribe(() => {
      this.toggle.emit();
    });
  }

  public ngOnChanges(changes: TypedChanges<TreatmentCardComponent>): void {
    if (changes.treatment) {
      this.isSelectedControl.setValue(this.treatment.selected, { emitEvent: false });
    }
  }

  public onProviderChange(providerId: string | string[] | null): void {
    if (!providerId) {
      return;
    }

    this.providerChange.emit(Array.isArray(providerId) ? providerId[0] : providerId);
  }
}
